import React, { useState, useEffect, useRef } from 'react';
import TagCarousel from '../../Components/Carousel/TagCarousel.container';
import VideoCarousel from '../../Components/Carousel/VideoCarousel.container';
import { translate } from '../../../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { updateActiveTagList, updateActiveVideoList } from './VideoPage.action';

const VideoPage = () => {
    const {
        videoList,
        tagList,
        activeTagList
    } = useSelector((state) => state.VideoReducer);
    const dispatch = useDispatch();
    const [selectedVideo, setSelectedVideo] = useState();
    const [clamped, setClamped] = useState(true);
    const [showButton, setShowButton] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);
    const handleClick = () => setIsExpanded((prevState) => !prevState);
    const deserializedTagList = tagList.tagList.length > 0 ? JSON.parse(tagList.tagList).map(tag => tag.toLowerCase()) : [];

    useEffect(() => {
        const videoId = fetchVideoId();
        const emptyList = ["alltags"];
        if (videoList.length > 0 && videoId !== null) {
            const video = videoList.find((video) => video.videoId === videoId);
            if (video) {
                setSelectedVideo(video);
                if (video.tags.length === 0 || video.tags === null) {
                    dispatch(updateActiveTagList(emptyList));
                } else {
                    dispatch(updateActiveTagList(video.tags));
                }
            } else {
                setSelectedVideo(videoList[0]);
                if (videoList[0].tags.length === 0 || videoList[0].tags === null) {
                    dispatch(updateActiveTagList(emptyList));
                } else {
                    dispatch(updateActiveTagList(videoList[0].tags));
                }
            }
        } else if (videoList.length > 0) {
            setSelectedVideo(videoList[0]);
            if (videoList[0].tags.length === 0 || videoList[0].tags === null) {
                dispatch(updateActiveTagList(emptyList));
            } else {
                dispatch(updateActiveTagList(videoList[0].tags));
            }
        }
        else {
            setSelectedVideo({});
            dispatch(updateActiveTagList([]));
        }
    }, []);

    useEffect(() => {
        let filteredVideos;
        const lowercaseActiveTagList = activeTagList.map((tag) => tag.toLowerCase());
        if (lowercaseActiveTagList.includes("alltags")) {
            filteredVideos = videoList;
        } else {
            filteredVideos = videoList.filter((video) => {
                const lowercaseTags = video.tags.map((tag) => tag.toLowerCase());
                return lowercaseTags.some((tag) => lowercaseActiveTagList.includes(tag));
            });
        }
        dispatch(updateActiveVideoList(filteredVideos));
    }, [activeTagList]);

    const descriptionRef = useRef(null);
    const clampRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            const clampElement = clampRef.current;
            const descriptionElement = descriptionRef.current;

            const checkClamp = () => {
                if (clampElement && descriptionElement) {
                    const isClamped =
                        descriptionElement.offsetHeight < descriptionElement.scrollHeight;
                    setShowButton(isClamped);
                    clampElement.style.display = isClamped && clamped ? 'block' : 'none';
                }
            };

            checkClamp();
            window.addEventListener('resize', checkClamp);

            return () => {
                window.removeEventListener('resize', checkClamp);
            };
        }, 0);
    }, [clamped]);

    const fetchVideoId = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const videoId = urlParams.get('videoId');
        return videoId;
    };

    const propData = {
        list: deserializedTagList,
        showCarouselArrows: "true",
    }

    const displayTags = () => {
        let item = selectedVideo;
        const matchingTags = item.tags
            .filter(tag => activeTagList.includes(tag.toLowerCase()))
            .map(tag => tag.toLowerCase());
        let displayTags = [];
        if (matchingTags.length >= 2) {
            displayTags = matchingTags.slice(0, 2);
        } else if (matchingTags.length === 1 && item.tags.length >= 2) {
            const firstTag = matchingTags[0];
            const secondTag = item.tags
                .find(tag => !matchingTags.includes(tag.toLowerCase()))?.toLowerCase();
            displayTags = [firstTag, secondTag];
        } else {
            displayTags = item.tags.length >= 2 ? item.tags.slice(0, 2).map(tag => tag.toLowerCase()) : item.tags;
        }
        displayTags = displayTags.map(tag => tag.charAt(0).toUpperCase() + tag.slice(1));
        return (
            <div className="vp-tag_container">
                {displayTags.map((tag, index) => (
                    <div key={index}>
                        <p>{tag}</p>
                    </div>
                ))}
            </div>
        );
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    if (!selectedVideo) {
        return null; // Render nothing if selectedVideo is not set
    }

    return (
        <div className="video-page-container grid-full-width">
            {
                selectedVideo !== null && (
                    <div className="video-page-content">
                        <div className="vp-selected-video">
                            <div className="vp-selected-video-item">
                                <div className="vp-video_container">
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src={`https://www.youtube.com/embed/${selectedVideo.videoId}`}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                {selectedVideo != null && displayTags()}
                                <div className="vp-title_container">
                                    <p>{selectedVideo.title}</p>
                                </div>

                                <div className='vp-description_container'>
                                    <p
                                        ref={descriptionRef}
                                        className={`vp-description ${isExpanded ? '' : 'clamp'}`}
                                        dangerouslySetInnerHTML={{ __html: selectedVideo.description }}
                                    >
                                    </p>
                                    {showButton && (
                                        <button onClick={handleClick} ref={clampRef}>{isExpanded ? translate('videopage.readless'): translate('videopage.readmore')}</button>
                                    )}
                                </div>
                                <div className="vp-publish_container">
                                    <p>{formatDate(selectedVideo.publishedAt)}</p>
                                </div>
                            </div>
                        </div>
                        <div className="video-page-other">
                            <div className="video-page-other-tag_carousel">
                                <TagCarousel
                                    propData={propData}
                                />
                            </div>
                            {videoList !== null && videoList.length > 0 &&
                                <div className="video-page-other-video_carousel">
                                    <VideoCarousel
                                    />
                                </div>
                            }
                        </div>
                    </div>
                )}
        </div>
    );
};

export default VideoPage;